/* index.tsx generated by @compiled/babel-plugin v3.0.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3138425zaO%7Bmargin-top%3Avar(--ds-space-200%2C1pc)%7D");
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { di } from 'react-magnetic-di';
import type AnalyticsEvent from '@atlaskit/analytics-next/AnalyticsEvent';
import Button from '@atlaskit/button/default/button';
import Modal from '@atlaskit/modal-dialog/modal-dialog';
import ModalBody from '@atlaskit/modal-dialog/modal-body';
import ModalFooter from '@atlaskit/modal-dialog/modal-footer';
import ModalHeader from '@atlaskit/modal-dialog/modal-header';
import ModalTitle from '@atlaskit/modal-dialog/modal-title';
import ModalTransition from '@atlaskit/modal-dialog/modal-transition';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import SectionMessage from '@atlaskit/section-message/message';
import { useAnalytics } from '@atlassian/conversation-assistant-instrumentation/controllers/analytics';
import { useConversationModal } from '../../../hooks/conversation-modal';
import messages from './messages';
const styles = {
  errorContainer: "_3138425zaO"
};
type DeleteConversationModalProps = {
  onDeleteConfirm: () => Promise<void | {
    error: string;
  }>;
  analyticsAttributes?: {
    touchpointSource?: string;
  };
};
export const DeleteConversationModal = ({
  onDeleteConfirm,
  analyticsAttributes: {
    touchpointSource
  } = {}
}: DeleteConversationModalProps): JSX.Element => {
  di(useConversationModal);
  const {
    sendAnalyticsEvent
  } = useAnalytics();
  const {
    formatMessage
  } = useIntl();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string>();
  const {
    isOpen,
    mode,
    conversation,
    closeModal
  } = useConversationModal();
  const isModalOpen = isOpen && mode === 'delete';
  const onDeleteClick = async (e: AnalyticsEvent) => {
    sendAnalyticsEvent(e.update({
      actionSubjectId: 'deleteConversationModalConfirmButton',
      attributes: {
        conversationId: conversation.id,
        touchpointSource
      }
    }));
    setIsSubmitting(true);
    try {
      const result = await onDeleteConfirm();
      if (result?.error) {
        setError(result.error);
      } else {
        closeModal();
        setError(undefined);
      }
    } catch (e) {
      setError(formatMessage(messages.genericErrorMessage));
    } finally {
      setIsSubmitting(false);
    }
  };
  const onCancelClick = (e: AnalyticsEvent) => {
    sendAnalyticsEvent(e.update({
      actionSubjectId: 'deleteConversationModalCancelButton',
      attributes: {
        conversationId: conversation.id,
        touchpointSource
      }
    }));
    setError(undefined);
    closeModal();
  };
  return <ModalTransition>
			{isModalOpen && <Modal onClose={(_, e) => onCancelClick(e)} width="small" testId="deleteConversationModal">
					<ModalHeader hasCloseButton>
						<ModalTitle>
							{formatMessage(messages.deleteConversationTitle, {
            name: conversation.name
          })}
						</ModalTitle>
					</ModalHeader>
					<ModalBody>
						<Stack>
							<Box>{formatMessage(messages.modalBody)}</Box>

							{!!error?.length && <Box xcss={styles.errorContainer}>
									<SectionMessage appearance="error">{error}</SectionMessage>
								</Box>}
						</Stack>
					</ModalBody>
					<ModalFooter>
						<Button appearance="subtle" onClick={(_, e) => onCancelClick(e)}>
							{formatMessage(messages.cancelButtonLabel)}
						</Button>
						<Button isLoading={isSubmitting} appearance="danger" onClick={(_, e) => onDeleteClick(e)}>
							{formatMessage(messages.deleteButtonLabel)}
						</Button>
					</ModalFooter>
				</Modal>}
		</ModalTransition>;
};